// extracted by mini-css-extract-plugin
export default {"link":"io5tA5","image":"XTnCDM","root":"kSyd9S"};